import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import { v4 } from 'uuid';

class FnbAdditionalItemStore {

    // Properties

    // Modal Create/Update Properties

    @observable showFnbAdditionalItemModal = false;
    @observable fnbAdditionalItemTitle = '';

    @observable tabOptionNameActiveKey = '1';
    @observable tabSubItemNameActiveKey = '1';

    @observable fnbAdditionalItems = [];
    @observable fnbAdditionalItemId = 0;

    @observable fnbTaskId = 0;
    @observable fnbTaskName = '';
    @observable isRequired = false;

    @observable optionId = '';
    @observable optionName = '';
    @observable optionNameEnglish = '';
    @observable optionNameChinese = '';
    @observable optionNameChineseTraditional = '';
    @observable optionNameThai = '';
    @observable optionNameJapanese = '';
    @observable optionNameVietnamese = '';

    @observable controlType = 'check';
    @observable maxNumber = 0;

    @observable fnbAdditionalItemDetails = [];
    @observable fnbAdditionalItemDetailId = 0;

    @observable subItemName = '';
    @observable subItemNameEnglish = '';
    @observable subItemNameChinese = '';
    @observable subItemNameChineseTraditional = '';
    @observable subItemNameThai = '';
    @observable subItemNameJapanese = '';
    @observable subItemNameVietnamese = '';

    @observable price = 0;

    @observable itemDetailTextButton = '+ Add Sub Item';
    @observable itemTextButton = 'Add Item';

    // Modal Search Item Properties

    @observable showFnbAdditinalItemSearchModal = false;
    @observable lastChildItems = [];
    @observable lastChildItemFilter = [];
    @observable itemSearchValue = '';

    // Helper Properties

    @observable fnbAdditionalItemListLoading = false;
    @observable fnbAdditionalItemModalLoading = false;

    // Initialization

    @action initFnbAdditionalItem() {
        this.fnbAdditionalItemListLoading = true;

        ApiCaller.FnbAdditionalItems.apiGetFnbAdditionalItems().then(fnbAdditionalItemResponses => {
            if (fnbAdditionalItemResponses) {
                this.fnbAdditionalItems = fnbAdditionalItemResponses;

                const languageCode = window.localStorage.getItem('lang') || 'en';
                ApiCaller.CmsTasks.getInRoomDiningAll(languageCode).then((fnbResponse) => {
                    if (fnbResponse) {
                        if (fnbResponse.items.length > 0) {
                            this.lastChildItems = fnbResponse.items;
                            this.lastChildItemFilter = this.lastChildItems;
                        }
                    }

                    this.fnbAdditionalItemListLoading = false;
                });
            } else {
                this.fnbAdditionalItems = [];
                this.fnbAdditionalItemListLoading = false;
            }
        });
    }

    @action initCreateFnbAdditionalItem() {
        this.fnbAdditionalItemTitle = 'Create IRD Additional Item';

        this.fnbAdditionalItemId = 0;
        this.fnbTaskName = '';
        this.isRequired = false;

        this.optionName = '';
        this.optionNameEnglish = '';
        this.optionNameChinese = '';
        this.optionNameChineseTraditional = '';
        this.optionNameThai = '';
        this.optionNameJapanese = '';
        this.optionNameVietnamese = '';

        this.controlType = 'check';

        if (this.controlType === 'check') {
            this.maxNumber = 3;
        } else {
            this.maxNumber = 0;
        }

        this.fnbAdditionalItemDetails = [];
        this.fnbAdditionalItemDetailId = 0;

        this.subItemName = '';
        this.subItemNameEnglish = '';
        this.subItemNameChinese = '';
        this.subItemNameChineseTraditional = '';
        this.subItemNameThai = '';
        this.subItemNameJapanese = '';
        this.subItemNameVietnamese = '';

        this.price = 0;

        this.itemTextButton = 'Add Item';

        this.showFnbAdditionalItemModal = true;
    }

    @action initUpdateFnbAdditionalItem(fnbAdditionalItemId) {
        this.fnbAdditionalItemModalLoading = true;
        this.fnbAdditionalItemTitle = 'Update IRD Additional Item';
        this.itemTextButton = 'Update Item';
        this.showFnbAdditionalItemModal = true;

        ApiCaller.FnbAdditionalItems.apiGetFnbAdditionalItemByFnbAdditionalItemId(fnbAdditionalItemId).then(fnbAdditionalItemResponse => {
            if (fnbAdditionalItemResponse) {
                this.fnbAdditionalItemId = fnbAdditionalItemResponse.fnbAdditionalItemId;
                this.fnbTaskId = fnbAdditionalItemResponse.fnbTaskId;
                this.fnbTaskName = fnbAdditionalItemResponse.fnbTaskName;
                this.isRequired = fnbAdditionalItemResponse.isRequired;

                this.optionId = fnbAdditionalItemResponse.optionId;
                this.optionName = fnbAdditionalItemResponse.optionName;
                this.optionNameEnglish = fnbAdditionalItemResponse.optionNameLang.english;
                this.optionNameChinese = fnbAdditionalItemResponse.optionNameLang.chinese;
                this.optionNameChineseTraditional = fnbAdditionalItemResponse.optionNameLang.chineseTraditional;
                this.optionNameThai = fnbAdditionalItemResponse.optionNameLang.thai;
                this.optionNameJapanese = fnbAdditionalItemResponse.optionNameLang.japanese;
                this.optionNameVietnamese = fnbAdditionalItemResponse.optionNameLang.vietnamese;

                this.controlType = fnbAdditionalItemResponse.controlType;
                this.maxNumber = fnbAdditionalItemResponse.maxNumber;

                this.fnbAdditionalItemDetails = fnbAdditionalItemResponse.itemDetails;
                this.fnbAdditionalItemDetailId = 0;

                this.subItemName = '';
                this.subItemNameEnglish = '';
                this.subItemNameChinese = '';
                this.subItemNameChineseTraditional = '';
                this.subItemNameThai = '';
                this.subItemNameJapanese = '';
                this.subItemNameVietnamese = '';

                this.price = 0;

                this.itemTextButton = 'Update Item';

                this.fnbAdditionalItemModalLoading = false;
            }
        });
    }

    @action initUpdateFnbAdditionalItemDetail(fnbAdditionalItemDetailId) {
        this.fnbAdditionalItemDetailId = fnbAdditionalItemDetailId;
        const fnbAdditionalItemDetail = this.fnbAdditionalItemDetails.find(fi => fi.fnbAdditionalItemDetailId === fnbAdditionalItemDetailId);
        if (fnbAdditionalItemDetail) {
            this.setSubItemNameEnglish(fnbAdditionalItemDetail.subItemNameLang.english);
            this.setSubItemNameChinese(fnbAdditionalItemDetail.subItemNameLang.chinese);
            this.setSubItemNameChineseTraditional(fnbAdditionalItemDetail.subItemNameLang.chineseTraditional);
            this.setSubItemNameThai(fnbAdditionalItemDetail.subItemNameLang.thai);
            this.setSubItemNameJapanese(fnbAdditionalItemDetail.subItemNameLang.japanese);
            this.setSubItemNameVietnamese(fnbAdditionalItemDetail.subItemNameLang.vietnamese);
            this.setPrice(fnbAdditionalItemDetail.price);
        } else {
            this.setSubItemNameEnglish('');
            this.setSubItemNameChinese('');
            this.setSubItemNameChineseTraditional('');
            this.setSubItemNameThai('');
            this.setSubItemNameJapanese('');
            this.setSubItemNameVietnamese('');
            this.setPrice(0);
        }

        this.itemDetailTextButton = 'Update Item';
    }

    // TRANSACTION

    @action searchItem() {
        this.lastChildItemFilter = this.lastChildItems.filter(item => {
            let itemTaskName = item.taskName.toLowerCase();
            return itemTaskName.indexOf(this.itemSearchValue.toLowerCase()) !== -1;
        });
    }

    @action searchItemSelected(taskId) {
        const item = this.lastChildItems.find(x => x.taskId === taskId);
        this.fnbTaskId = taskId;
        this.fnbTaskName = item.taskName;
    }

    // Transaction Item

    @action createFnbAdditionalItem() {
        this.fnbAdditionalItemModalLoading = true;

        this.fnbAdditionalItemDetails.map(itemDetail => {
            itemDetail.fnbAdditionalItemDetailId = 0;
            return itemDetail;
        });

        const newItem = {
            'fnbAdditionalItemId': 0,
            'fnbTaskId': this.fnbTaskId,
            'fnbTaskName': this.fnbTaskName,
            'controlType': this.controlType,
            'maxNumber': this.maxNumber,
            'optionName': this.optionName,
            'optionNameLang': {
                'english': this.optionNameEnglish,
                'chinese': this.optionNameChinese,
                'chineseTraditional': this.optionNameChineseTraditional,
                'thai': this.optionNameThai,
                'japanese': this.optionNameJapanese,
                'vietnamese': this.optionNameVietnamese
            },
            'itemDetails': this.fnbAdditionalItemDetails,
            'isRequired': this.isRequired,
            'isDeleted': false
        };

        return ApiCaller.FnbAdditionalItems.apiCreateFnbAdditionalItem(newItem).then((createFnbAdditionalItemResponse) => {
            this.fnbAdditionalItemModalLoading = false;
            this.showFnbAdditionalItemModal = false;

            let isSuccess = false;

            if (createFnbAdditionalItemResponse) {
                if (!createFnbAdditionalItemResponse.isError) {
                    isSuccess = true;
                    this.initFnbAdditionalItem();
                }
            }

            return isSuccess;
        });
    }

    @action updateFnbAdditionalItem() {
        this.fnbAdditionalItemModalLoading = true;

        this.fnbAdditionalItemDetails.map(itemDetail => {
            itemDetail.fnbAdditionalItemDetailId = 0;
            itemDetail.fnbAdditionalItemId = this.fnbAdditionalItemId;
            return itemDetail;
        });

        const updateItem = {
            'fnbAdditionalItemId': this.fnbAdditionalItemId,
            'fnbTaskId': this.fnbTaskId,
            'fnbTaskName': this.fnbTaskName,
            'controlType': this.controlType,
            'maxNumber': this.maxNumber,
            'optionId': this.optionId,
            'optionName': this.optionName,
            'optionNameLang': {
                'english': this.optionNameEnglish,
                'chinese': this.optionNameChinese,
                'chineseTraditional': this.optionNameChineseTraditional,
                'thai': this.optionNameThai,
                'japanese': this.optionNameJapanese,
                'vietnamese': this.optionNameVietnamese
            },
            'itemDetails': this.fnbAdditionalItemDetails,
            'isRequired': this.isRequired,
            'isDeleted': false
        };

        return ApiCaller.FnbAdditionalItems.apiUpdateFnbAdditionalItem(this.fnbAdditionalItemId, updateItem).then((updateFnbAdditionalItemResponse) => {
            this.fnbAdditionalItemModalLoading = false;
            this.showFnbAdditionalItemModal = false;

            let isSuccess = false;

            if (updateFnbAdditionalItemResponse) {
                if (!updateFnbAdditionalItemResponse.isError) {
                    isSuccess = true;
                    this.initFnbAdditionalItem();
                }
            }

            return isSuccess;
        });
    }

    @action deleteUpdateFnbAdditionalItem(fnbAdditionalItemId) {
        this.fnbAdditionalItemListLoading = true;

        return ApiCaller.FnbAdditionalItems.apiDeleteFnbAdditionalItem(fnbAdditionalItemId).then((deleteFnbAdditionalItemResponse) => {
            this.fnbAdditionalItemListLoading = false;

            let isSuccess = false;

            if (deleteFnbAdditionalItemResponse) {
                if (!deleteFnbAdditionalItemResponse.isError) {
                    isSuccess = true;
                    this.initFnbAdditionalItem();
                }
            }

            return isSuccess;
        });
    }

    // Transaction Item Detail

    @action createOrUpdateFnbAdditionalItemDetail() {
        if (this.fnbAdditionalItemDetailId === 0) {
            const newItemDetail = {
                'fnbAdditionalItemDetailId': v4(),
                'fnbAdditionalItemId': 0,
                'subItemName': this.subItemName,
                'subItemNameLang': {
                    'english': this.subItemNameEnglish,
                    'chinese': this.subItemNameChinese,
                    'chineseTraditional': this.subItemNameChineseTraditional,
                    'thai': this.subItemNameThai,
                    'japanese': this.subItemNameJapanese,
                    'vietnamese': this.subItemNameVietnamese
                },
                'price': this.price,
                'isDeleted': false
            };

            this.fnbAdditionalItemDetails.push(newItemDetail);
        } else {
            let fnbAdditionalItemDetail = this.fnbAdditionalItemDetails.find(fi => fi.fnbAdditionalItemDetailId === this.fnbAdditionalItemDetailId);
            fnbAdditionalItemDetail.subItemName = this.subItemName;
            fnbAdditionalItemDetail.subItemNameLang.english = this.subItemNameEnglish;
            fnbAdditionalItemDetail.subItemNameLang.chinese = this.subItemNameChinese;
            fnbAdditionalItemDetail.subItemNameLang.chineseTraditional = this.subItemNameChineseTraditional;
            fnbAdditionalItemDetail.subItemNameLang.thai = this.subItemNameThai;
            fnbAdditionalItemDetail.subItemNameLang.japanese = this.subItemNameJapanese;
            fnbAdditionalItemDetail.subItemNameLang.vietnamese = this.subItemNameVietnamese;
            fnbAdditionalItemDetail.price = this.price;
        }

        this.fnbAdditionalItemDetailId = 0;

        this.setSubItemNameEnglish('');
        this.setSubItemNameChinese('');
        this.setSubItemNameChineseTraditional('');
        this.setSubItemNameThai('');
        this.setSubItemNameJapanese('');
        this.setSubItemNameVietnamese('');
        this.setPrice(0);

        this.itemDetailTextButton = '+ Add Sub Item';
    }

    @action deleteFnbAdditionalItemDetail(fnbAdditionalItemDetailId) {
        this.fnbAdditionalItemDetails = this.fnbAdditionalItemDetails.filter(fi => fi.fnbAdditionalItemDetailId !== fnbAdditionalItemDetailId);
        this.fnbAdditionalItemDetailId = 0;

        this.setSubItemNameEnglish('');
        this.setSubItemNameChinese('');
        this.setSubItemNameChineseTraditional('');
        this.setSubItemNameThai('');
        this.setSubItemNameJapanese('');
        this.setSubItemNameVietnamese('');
        this.setPrice(0);

        this.itemDetailTextButton = '+ Add Sub Item';
    }

    @action cancelFnbAdditionalItemDetail() {
        this.fnbAdditionalItemDetailId = 0;

        this.setSubItemNameEnglish('');
        this.setSubItemNameChinese('');
        this.setSubItemNameChineseTraditional('');
        this.setSubItemNameThai('');
        this.setSubItemNameJapanese('');
        this.setSubItemNameVietnamese('');
        this.setPrice(0);

        this.itemDetailTextButton = '+ Add Sub Item';
    }

    // SET Properties

    @action setShowFnbAdditionalItemModal(value) {
        this.showFnbAdditionalItemModal = value;
        if (!value) {
            this.tabOptionNameActiveKey = '1';
            this.tabSubItemNameActiveKey = '1';
        }
    }

    @action setShowFnbAdditinalItemSearchModal(value) {
        this.showFnbAdditinalItemSearchModal = value;
    }

    @action setItemSearchValue(value) {
        this.itemSearchValue = value
    }

    @action setOptionNameEnglish(value) {
        this.optionNameEnglish = value;
        this.optionName = this.optionNameEnglish;
    }

    @action setOptionNameChinese(value) {
        this.optionNameChinese = value;
    }

    @action setOptionNameChineseTraditional(value) {
        this.optionNameChineseTraditional = value;
    }

    @action setOptionNameThai(value) {
        this.optionNameThai = value;
    }

    @action setOptionNameJapanese(value) {
        this.optionNameJapanese = value;
    }

    @action setOptionNameVietnamese(value) {
        this.optionNameVietnamese = value;
    }

    @action setIsRequired(value) {
        this.isRequired = value;
    }

    @action setControlType(value) {
        this.controlType = value;
    }

    @action setMaxNumber(value) {
        this.maxNumber = value;
    }

    @action setSubItemNameEnglish(value) {
        this.subItemNameEnglish = value;
        this.subItemName = this.subItemNameEnglish;
    }

    @action setSubItemNameChinese(value) {
        this.subItemNameChinese = value;
    }

    @action setSubItemNameChineseTraditional(value) {
        this.subItemNameChineseTraditional = value;
    }

    @action setSubItemNameThai(value) {
        this.subItemNameThai = value;
    }

    @action setSubItemNameJapanese(value) {
        this.subItemNameJapanese = value;
    }

    @action setSubItemNameVietnamese(value) {
        this.subItemNameVietnamese = value;
    }

    @action setPrice(value) {
        this.price = value;
    }

    @action setTabOptionNameActiveKey(value) {
        this.tabOptionNameActiveKey = value;
    }

    @action setTabSubItemNameActiveKey(value) {
        this.tabSubItemNameActiveKey = value;
    }
}

export default new FnbAdditionalItemStore()